// Sticky add to cart on mobile (snippets/product-sticky-add-to-cart.liquid).
// The theme only shows the bar once the product form has scrolled out above the screen. On a phone the form sits below
// the gallery, so the bar stays hidden for the whole first screen. Here it shows whenever the form's add to cart button is
// out of view, above or below, and still hides at the footer. The theme's own .is-visible keeps running for desktop;
// assets/custom.css lets data-mobile-visible decide below 700px, and on ad landing pages at every width.

const setup = (sticky) => {
  if (sticky.dataset.mobileWatch) return;

  const form = document.getElementById(sticky.getAttribute('main-product-form'));
  const footer = document.querySelector('.shopify-section--footer');
  // Ad landing pages: the hero has its own buttons, so the bar waits until it has scrolled away (on every screen size)
  const hero = document.querySelector('[data-landing-hero]');
  if (!form) return;

  sticky.dataset.mobileWatch = 'true';

  let formInView = true;
  let footerInView = false;
  let heroInView = Boolean(hero);

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.target === form) formInView = entry.isIntersecting;
      if (entry.target === footer) footerInView = entry.isIntersecting;
      if (entry.target === hero) heroInView = entry.isIntersecting;
    });

    sticky.dataset.mobileVisible = String(!formInView && !footerInView && !heroInView);
  });

  observer.observe(form);
  if (footer) observer.observe(footer);
  if (hero) observer.observe(hero);
};

const run = () => document.querySelectorAll('product-sticky-add-to-cart').forEach(setup);

run();
document.addEventListener('shopify:section:load', run);
// A landing page swapped the product in its buy block (assets/featured-product-swap.js): watch the new bar
document.addEventListener('featured-product:swapped', run);
